export default "__VITE_ASSET__CMFaqTwM__"